import { z } from "zod";

export const GOAL_DETAILS_MODALS = [
	"updateProgress",
	"archive",
	"complete",
	"delete",
	"share",
	"edit-as-of-date",
] as const;
export const ActivityStreamTabName = ["activity", "details", "progress"] as const;

// Matches MIN_GOAL_DATE_YEAR server-side; anything earlier is a mistyped year.
export const MIN_AS_OF_DATE = new Date("1900-01-01T00:00:00.000Z");
export const MIN_AS_OF_DATE_ERROR = "Date must be on or after January 1, 1900";
const CONFIG = {
	queryParametersSchema: z.object({
		modal: z.enum(GOAL_DETAILS_MODALS).optional().catch(undefined),
		initialGoalProgressValue: z.number().optional().catch(undefined),
		editHistoryEntryId: z.string().optional().catch(undefined),
	}),
	savedQueryParametersSchema: z.object({
		chartsHidden: z.boolean().optional().catch(false),
		isActivityStreamClosed: z.boolean().optional().catch(false),
		activityStreamTab: z.enum(ActivityStreamTabName).optional().catch("progress"),
		descriptionExpanded: z.boolean().optional().catch(false),
	}),
};

export type GoalProgressPageState = z.infer<typeof CONFIG.queryParametersSchema>;

export default CONFIG;
